export const initialValues = () => ({
  nameDepartment: "",
  description: "",
});
